var render = function render(){var _vm=this,_c=_vm._self._c;return _c('v-app',{staticClass:"relative full-width",style:(`height: ${ _vm.innerHeight }px !important`),attrs:{"light":""}},[_c('router-view',{staticClass:"absolute full-width full-height"})],1)
}
var staticRenderFns = []

export { render, staticRenderFns }